import styled from 'styled-components'
import { font } from 'lib/core/resources/helpers/styled'
import { link } from 'app/sofia/resources/theme/css'

export const Wrapper = styled.div`
  .outlined {
    color: ${props => props.theme.palette.primary.alphaDark};
    font: ${font('default', 'medium', '16px/1')};
    border-color: ${props => props.theme.palette.primary.alphaDark};
    transition: background 300ms ease, opacity 300ms ease;

    &:hover {
      background-color: ${props => props.theme.palette.primary.alphaDark};
      color: ${props => props.theme.palette.general.light};
    }

    &:active {
      background-color: ${props => props.theme.palette.general.greyDark};
      border-color: ${props => props.theme.palette.general.greyDark};
      color: ${props => props.theme.palette.general.light};
    }
  }
`

export const ForgotPassword = styled.div`
  font-size: 14px;
  transform: translateY(-20px);
  text-align: right;
  user-select: none;

  a {
    ${link}
  }
`
